<template>
  <div>
    <modal-provider name="send-bill-modal" :width="500" :title="$t('mail.send.text')">
      <form @submit.prevent="handleSubmit">
        <div class="control-box control-box--email">
          <div class="control-box__inputs">
            <div class="control-box__email">
              <EmailInput
                :errorText="!isEmailValid ? $t('invalid_email') : ''"
                :emailValue="email"
                isRequired
                @getValue="handleEmail"
              >
              </EmailInput>
              <p v-if="serverMessage" class="control-box__help-block help-block help-block-error">
                {{ serverMessage }}
              </p>
            </div>
            <Button nativeType="submit" :isDisabled="!isEmailValid || isFormSubmiting" class="btn btn--subscribe">
              {{ $t('mail.send.btn.text') }}
            </Button>
          </div>
        </div>
      </form>
    </modal-provider>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EmailInput from '@/components/inputs/EmailInput'
import Button from '@/components/inputs/Button'
import api from '@/api'

export default {
  name: 'SendBillModal',
  components: {
    EmailInput,
    Button
  },
  data () {
    return {
      isEmailValid: false,
      isFormSubmiting: false,
      email: '',
      serverMessage: '',
      orderId: null
    }
  },
  computed: {
    ...mapState({
      userEmail: state => state.user.user_data?.email
    })
  },
  watch: {
    userEmail: {
      immediate: true,
      handler (val) {
        this.email = val || ''
      }
    }
  },
  created () {
    window.addEventListener('sendBillClickTrigger', event => {
      this.orderId = event.detail.orderId
      this.$modal.show('send-bill-modal')
    })
  },
  methods: {
    handleSubmit () {
      if (this.isEmailValid && !this.isFormSubmiting) {
        this.isFormSubmiting = true
        api.cabinet
          .sendBill({ email: this.email, orderId: this.orderId })
          .then(data => {
            if (data.status === 'error') {
              this.serverMessage = data.message
            } else {
              this.$modal.hide('send-bill-modal')
              this.$notify({
                group: 'success',
                text: data.message,
                type: 'success'
              })
            }
          })
          .catch(err => {
            this.$modal.hide('send-bill-modal')
            this.$notify({
              group: 'error',
              text: err.message,
              type: 'error'
            })
          })
          .finally(() => {
            this.isFormSubmiting = false
          })
      }
    },
    handleEmail (evt) {
      this.email = evt.value
      this.isEmailValid = evt.isValid
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep
  .modal-body
    padding-top: 0
    padding-bottom: 30px
    +mmax(450)
      padding-bottom: 20px

.control-box
  margin-bottom: 0

.control-box__inputs
  display: flex
  flex-flow: row wrap
  align-items: flex-start
  justify-content: space-between

.control-box__email
  display: flex
  flex-direction: column
  width: 60%

.control
  height: 40px
  box-shadow: none

.btn--subscribe
  font-size: 14px
  height: 40px
  width: 35%
  margin-top: 5px
  +mmax(450)
    width: auto
    padding: 0 20px

+mmax(450)
  .control-box__email
    width: 100%
  .btn--subscribe
    margin-top: 15px
</style>
